import { createStore } from 'hox';
import { useState } from 'react';

import { AdministratorProps } from '@Types/administrator';

function useLocalAccounts() {
  const [localAccounts, setLocalAccounts] = useState<AdministratorProps[] | []>(
    []
  );
  return {
    localAccounts,
    setLocalAccounts,
  };
}
export const [useLocalAccountsStore, LocalStoreProvider] =
  createStore(useLocalAccounts);
